let __lockCount = 0
let __prevOverflow: string | null = null

export function lockScroll() {
  if (typeof document === 'undefined') return
  if (__lockCount === 0) {
    __prevOverflow = document.documentElement.style.overflow
    document.documentElement.style.overflow = 'hidden'
  }
  __lockCount++
}

export function unlockScroll() {
  if (typeof document === 'undefined') return
  __lockCount = Math.max(0, __lockCount - 1)
  if (__lockCount === 0) {
    const prev = __prevOverflow ?? ''
    document.documentElement.style.overflow = prev
    __prevOverflow = null
  }
}

